<template>
  <div id="app">
    <nav-view></nav-view>
    <router-view />
    <footer-view></footer-view>
  </div>
</template>
<script>
import NavView from "./components/NavView";
import FooterView from "./components/FooterView";
export default {
  components: {
    NavView,
    FooterView
  },
};
</script>
<style lang="scss"></style>
